'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLaunchRawData = setLaunchRawData;
exports.clearLaunchRawData = clearLaunchRawData;
var SET_LAUNCH_RAW_DATA = exports.SET_LAUNCH_RAW_DATA = 'SET_GTM_DATA_LAYER';
var CLEAR_LAUNCH_RAW_DATA = exports.CLEAR_LAUNCH_RAW_DATA = 'CLEAR_GTM_DATA_LAYER';

function setLaunchRawData(rawData) {
  return { rawData: rawData, type: SET_LAUNCH_RAW_DATA };
}

function clearLaunchRawData() {
  return { type: CLEAR_LAUNCH_RAW_DATA };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/launch.js
// module id = 576
// module chunks = 0